const KEY = 'nebulark.hiScore.v1';

/** Read the persisted hi-score from localStorage. Returns 0 on any failure. */
export function loadHiScore(): number {
  try {
    if (typeof localStorage === 'undefined') return 0;
    const raw = localStorage.getItem(KEY);
    if (raw === null) return 0;
    const n = Number.parseInt(raw, 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

/** Save a new hi-score to localStorage. Silently ignores failures. */
export function saveHiScore(score: number): void {
  try {
    if (typeof localStorage === 'undefined') return;
    if (!Number.isFinite(score) || score < 0) return;
    localStorage.setItem(KEY, String(Math.floor(score)));
  } catch {
    // Ignore — privacy mode / quota errors are non-fatal.
  }
}
